import { Helmet } from "react-helmet-async";
import config from "../config/stateConfig";

const UPDATED = "August 2026";

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-16" data-testid="terms-page">
      <Helmet>
        <title>{`Terms of Use | ${config.brand}`}</title>
        <meta name="description" content={`The terms that govern your use of ${config.domain}, a free attorney-connection service for ${config.stateName} accident victims.`} />
        <link rel="canonical" href={`https://${config.domain}/terms`} />
      </Helmet>

      <h1 className="text-4xl sm:text-5xl font-bold text-navy mb-3">Terms of Use</h1>
      <p className="text-sm text-navy/50 mb-10">Last updated: {UPDATED}</p>

      <div className="prose prose-neutral max-w-none space-y-6 text-navy/80 leading-relaxed">
        <p>
          These Terms of Use govern your access to and use of {config.domain} (the "Site"),
          operated by {config.brand}. By using the Site you agree to these terms. If you do not
          agree, please do not use the Site.
        </p>

        <h2 className="text-2xl font-semibold text-navy">Not a law firm; no legal advice</h2>
        <p>{config.brand} is not a law firm and does not provide legal advice, opinions, or
          representation. The Site is a free service that connects visitors with independent
          attorneys. Content on the Site is for general informational purposes only and is not a
          substitute for advice from a licensed attorney about your specific situation.</p>

        <h2 className="text-2xl font-semibold text-navy">No attorney–client relationship</h2>
        <p>Using the Site or submitting a request does not create an attorney–client relationship.
          Such a relationship is formed only through a separate, signed agreement with an attorney.</p>

        <h2 className="text-2xl font-semibold text-navy">Connecting with attorneys</h2>
        <p>When you submit a request, we may share your information with one or more independent
          attorneys who may contact you regarding a free, no-obligation consultation. We do not
          guarantee that any attorney will accept your matter or achieve any particular outcome.
          Past results do not guarantee future outcomes.</p>

        <h2 className="text-2xl font-semibold text-navy">Your responsibilities</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Provide accurate information when using the case-review form.</li>
          <li>Use the Site only for lawful, personal, non-commercial purposes.</li>
          <li>Do not attempt to disrupt, misuse, or gain unauthorized access to the Site.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-navy">Informational content & external links</h2>
        <p>Articles and resources on the Site describe general {config.stateName} legal concepts and
          may not reflect the most current law or your specific circumstances. The Site may link to
          third-party websites, which are governed by their own terms and policies.</p>

        <h2 className="text-2xl font-semibold text-navy">Disclaimer &amp; limitation of liability</h2>
        <p>The Site is provided "as is" without warranties of any kind. To the fullest extent
          permitted by law, {config.brand} is not liable for any damages arising from your use of the
          Site or from any attorney connection made through it.</p>

        <h2 className="text-2xl font-semibold text-navy">Changes</h2>
        <p>We may update these terms from time to time. Continued use of the Site after changes
          constitutes acceptance of the updated terms.</p>

        <h2 className="text-2xl font-semibold text-navy">Contact</h2>
        <p>Questions about these terms can be directed to us through our{" "}
          <a href="/contact" className="text-terracotta font-semibold hover:underline">contact page</a>{" "}
          or by phone at{" "}
          <a href={`tel:${config.phoneTel}`} className="text-terracotta font-semibold hover:underline">{config.phone}</a>.
        </p>
      </div>
    </div>
  );
}
